import axios from "axios";
import { API_URL } from "src/scenes/App";
import { UserKeys } from "src/constants/userDetails";

export const getContacts = async (audienceUuid) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.get(`${API_URL}/company/emailCampaigns/audience/${audienceUuid}/contacts`, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const saveContacts = async (payload) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.post(`${API_URL}/company/emailCampaigns/audience`, payload, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const updateContacts = async (audienceUuid, payload) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.put(`${API_URL}/company/emailCampaigns/audience/${audienceUuid}/contacts`, payload, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const deleteContact = async (audienceUuid, contactUuid) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.delete(`${API_URL}/company/emailCampaigns/audience/${audienceUuid}/contacts/${contactUuid}`, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};